"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _dlgNewLineAvenant = _interopRequireDefault(require("./dlgNewLineAvenant"));

var _moment = _interopRequireDefault(require("moment"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'LotDetailAvenantsMarchePrinc',
  props: ['idLot'],
  components: {
    dlgNewLineAvenant: _dlgNewLineAvenant.default
  },
  data: function data() {
    return {
      CONST: CONST,
      dlgNewLineVisible: false,
      refresh: 0,
      lotsDetail: [],
      calculs: [],
      totaux: [],
      modeEdit: false,
      // ---
      numAvenant: null,
      idAvenantMPrinc: null,
      rowsForCancelling: [],
      rowsForSaving: [],
      avenantsMarchePrincipal: [],
      nbCol: 0
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['affaire']), {
    maxOrdre: function maxOrdre() {
      var max = 0;

      if (this.lotsDetail.length > 0) {
        max = Math.max.apply(Math, this.$store.getters.affaire.lotsDetail.map(function (x) {
          return x.ordre;
        }));
      }

      return max + 1;
    }
  }),
  created: function created() {
    var _this = this;

    this.$watch('$root.modeEdit', function (newValue) {
      if (newValue === false) {
        _this.modeEdit = false;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.nbCol = this.getNbCol();

    _eventBus.EventBus.$on('REFRESH', function (params) {
      var typeLigne = [CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE, CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT_MARCHE_PRINCIPAL, CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE];
      _this2.lotsDetail = _this2.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.calculs = _this2.$store.getters.affaire.calculs.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && typeLigne.includes(x.type_lot_detail);
      });
      _this2.totaux = _this2.$store.getters.affaire.calculs.lots.filter(function (x) {
        return x.id === _this2.idLot;
      });

      if (params) {
        _this2.nbCol = _this2.affaire.nbColAvenantMarchePrincipal;
      }
    });

    _eventBus.EventBus.$on('AVENANT_MARCHE_PRINC_EDIT', function (params) {
      _this2.modeEdit = true;

      _this2.onEditAvenant(params);
    });

    _eventBus.EventBus.$on('AVENANT_MARCHE_PRINC_NEW', function () {
      _this2.nbCol = _this2.getNbCol();
      _this2.numAvenant = null;
      _this2.modeEdit = true;
      _this2.rowsForSaving = [];
    });

    _eventBus.EventBus.$on('AVENANT_MARCHE_PRINC_CANCEL', function () {
      _this2.modeEdit = false;

      _this2.onCancelAvenant();
    });

    _eventBus.EventBus.$on('AVENANT_MARCHE_PRINC_SAVE', function (params) {
      _this2.modeEdit = false;

      _this2.onSaveAvenant(params);
    });

    _eventBus.EventBus.$on('AVENANT_REFRESH_ALL', function (params) {
      _this2.nbCol = _this2.getNbCol();
      _this2.modeEdit = params;
    });

    this.refresh++;
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('REFRESH');

    _eventBus.EventBus.$off('AVENANT_MARCHE_PRINC_NEW');

    _eventBus.EventBus.$off('AVENANT_MARCHE_PRINC_EDIT');

    _eventBus.EventBus.$off('AVENANT_MARCHE_PRINC_CANCEL');

    _eventBus.EventBus.$off('AVENANT_MARCHE_PRINC_SAVE');
  },
  methods: {
    gestMens: function gestMens(numCol) {
      if (this.affaire.calculs.affaire) {
        return this.affaire.calculs.affaire.colonneAvenantMarchePrincipalEntete[numCol].periode_gestmens;
      }
    },
    dateCol: function dateCol(numCol) {
      if (this.affaire.calculs.affaire) {
        // return this.affaire.calculs.affaire.dateColonneAvenantMarchePrincipal[numCol]
        return this.affaire.calculs.affaire.colonneAvenantMarchePrincipalEntete[numCol].date_creation;
      }
    },
    getNbCol: function getNbCol() {
      return this.affaire.nbColAvenantMarchePrincipal;
    },
    mtTotalLotColonneAvenant: function mtTotalLotColonneAvenant(index, column) {
      return this.totaux[index] && this.totaux[index].mtTotalLotColonneAvenantMarchePrincipal[column] ? this.totaux[index].mtTotalLotColonneAvenantMarchePrincipal[column] : '';
    },
    mtTotalLotLigneAvenant: function mtTotalLotLigneAvenant(index) {
      return this.totaux[index] ? this.totaux[index].mtTotalLotLigneAvenantMarchePrincipal : '';
    },
    canAddAvenant: function canAddAvenant(scope) {
      return scope.row.validation === 1 && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE || scope.row.validation === 1 && scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.SUPPLEMENTAIRE || scope.row.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.AVENANT_MARCHE_PRINCIPAL;
    },
    handleInput: function () {
      var _handleInput = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(scope, col, mtAvenant, action) {
        var data, avenant, index;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {};
                _context.next = 3;
                return this.affaire.avenantsMarchePrincipal.find(function (x) {
                  return x.id_lot_detail === scope.row.id && x.num_colonne === col;
                });

              case 3:
                avenant = _context.sent;

                if (avenant) {
                  // mise à jour de l'avenant
                  data = {
                    id_lot_detail: scope.row.id,
                    id_avenant_mprinc: this.idAvenantMPrinc,
                    num_colonne: col,
                    mt_avenant: mtAvenant || null,
                    date_creation: avenant.date_creation,
                    periode_gestmens: avenant.periode_gestmens
                  };

                  if (avenant.id) {
                    data.id = avenant.id;
                  }
                } else {
                  // nouvel valeur d'avenant
                  data = {
                    id_lot_detail: scope.row.id,
                    num_colonne: col,
                    mt_avenant: mtAvenant || null,
                    date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
                    periode_gestmens: this.affaire.YYYYMM ? this.affaire.YYYYMM : ''
                  };
                } // on sauvegarde les valeurs saisies en vue d'etre sauvegardées en base de données


                _context.next = 7;
                return this.rowsForSaving.findIndex(function (x) {
                  return x.id_lot_detail === scope.row.id && x.num_colonne === col;
                });

              case 7:
                index = _context.sent;

                if (index >= 0) {
                  this.rowsForSaving[index] = data;
                } else {
                  this.rowsForSaving.push(data);
                } // on mémorise la nouvelle valeur saisie dans la structure de données globale


                _context.next = 11;
                return this.$store.dispatch('affaire/setAvenantMarchePrincipal', data);

              case 11:
                if (action === 'refresh_calcul') {
                  _eventBus.EventBus.$emit('REFRESH_CALCULS');
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleInput(_x, _x2, _x3, _x4) {
        return _handleInput.apply(this, arguments);
      }

      return handleInput;
    }(),
    onCancelAvenant: function () {
      var _onCancelAvenant = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _iterator, _step, avenant, _iterator2, _step2, _avenant;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // pour vider le champ de saisie et ne pas avoir l'ancienne valeur quand on fera "Nouvel avenant"
                this.lotsDetail.forEach(function (row) {
                  if (row.mt_avenant) {
                    row.mt_avenant = '';
                  }
                }); // on restaure les valeurs avant modification dans la structure de données

                if (!(this.rowsForSaving.length > 0)) {
                  _context2.next = 19;
                  break;
                }

                _iterator = _createForOfIteratorHelper(this.rowsForSaving);
                _context2.prev = 3;

                _iterator.s();

              case 5:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 11;
                  break;
                }

                avenant = _step.value;
                _context2.next = 9;
                return this.$store.dispatch('affaire/delAvenantMarchePrincipal', avenant);

              case 9:
                _context2.next = 5;
                break;

              case 11:
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](3);

                _iterator.e(_context2.t0);

              case 16:
                _context2.prev = 16;

                _iterator.f();

                return _context2.finish(16);

              case 19:
                if (!(this.rowsForCancelling.length > 0)) {
                  _context2.next = 37;
                  break;
                }

                _iterator2 = _createForOfIteratorHelper(this.rowsForCancelling);
                _context2.prev = 21;

                _iterator2.s();

              case 23:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 29;
                  break;
                }

                _avenant = _step2.value;
                _context2.next = 27;
                return this.$store.dispatch('affaire/setAvenantMarchePrincipal', _avenant);

              case 27:
                _context2.next = 23;
                break;

              case 29:
                _context2.next = 34;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t1 = _context2["catch"](21);

                _iterator2.e(_context2.t1);

              case 34:
                _context2.prev = 34;

                _iterator2.f();

                return _context2.finish(34);

              case 37:
                _eventBus.EventBus.$emit('AVENANT_REFRESH_ALL', false);

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 13, 16, 19], [21, 31, 34, 37]]);
      }));

      function onCancelAvenant() {
        return _onCancelAvenant.apply(this, arguments);
      }

      return onCancelAvenant;
    }(),
    onEditAvenant: function onEditAvenant(params) {
      var _this3 = this;

      this.numAvenant = params && params.numEntete ? params.numEntete : null;
      this.idAvenantMPrinc = params && params.idAvenantMPrinc ? params.idAvenantMPrinc : null; // on mémorise les valeurs initiales des avenants au marché principal

      var avenants = this.$store.getters.affaire.avenantsMarchePrincipal.filter(function (x) {
        return x.id_lot === _this3.idLot && x.num_colonne === _this3.numAvenant;
      });
      this.rowsForCancelling = JSON.parse(JSON.stringify(avenants));
      this.rowsForSaving = [];
    },
    onSaveAvenant: function () {
      var _onSaveAvenant = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee3(params) {
        var _iterator3, _step3, row, data, _data, i;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iterator3 = _createForOfIteratorHelper(this.rowsForSaving);
                _context3.prev = 1;

                _iterator3.s();

              case 3:
                if ((_step3 = _iterator3.n()).done) {
                  _context3.next = 16;
                  break;
                }

                row = _step3.value;

                if (!row.id) {
                  _context3.next = 11;
                  break;
                }

                // mise à jour
                data = {
                  id: row.id,
                  id_avenant_mprinc: params.idAvenantMPrinc,
                  id_lot_detail: row.id_lot_detail,
                  num_colonne: row.num_colonne,
                  mt_avenant: row.mt_avenant || null,
                  date_creation: row.date_creation,
                  periode_gestmens: row.periode_gestmens,
                  date_modification: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss')
                };
                _context3.next = 9;
                return this.$store.dispatch('affaire/updateAvenantMarchePrincipal', [data, this.idLot]);

              case 9:
                _context3.next = 14;
                break;

              case 11:
                // creation
                _data = {
                  id_avenant_mprinc: params.idAvenantMPrinc,
                  id_lot_detail: row.id_lot_detail,
                  num_colonne: row.num_colonne,
                  mt_avenant: row.mt_avenant || null,
                  date_creation: (0, _moment.default)().format('YYYY-MM-DD HH:mm:ss'),
                  periode_gestmens: this.affaire.YYYYMM ? this.affaire.YYYYMM : ''
                };
                _context3.next = 14;
                return this.$store.dispatch('affaire/insertAvenantMarchePrincipal', [_data, this.idLot]);

              case 14:
                _context3.next = 3;
                break;

              case 16:
                _context3.next = 21;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](1);

                _iterator3.e(_context3.t0);

              case 21:
                _context3.prev = 21;

                _iterator3.f();

                return _context3.finish(21);

              case 24:
                // pour eviter d'avoir les anciennes saisies dans les champs de saisie d'un nouvel avenant
                for (i = 0; i < this.$store.getters.affaire.lotsDetail.length; i++) {
                  this.$store.getters.affaire.lotsDetail[i].mt_avenant = null;
                } // on rafraichi tout


                _eventBus.EventBus.$emit('AVENANT_REFRESH_ALL', false);

              case 26:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 18, 21, 24]]);
      }));

      function onSaveAvenant(_x5) {
        return _onSaveAvenant.apply(this, arguments);
      }

      return onSaveAvenant;
    }(),
    renderHeader: function renderHeader(h, _ref) {
      var column = _ref.column,
          $index = _ref.$index;
      var label = column.label.split('\\n');
      return h('div', {}, [h('span', label[0]), h('br'), h('span', label[1])]);
    }
  }
};
exports.default = _default;